import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { register } from "../../contexts/actions/register";
import { useStateContext } from '../../contexts/ContextProvider'

export default () => {
  const [form, setForm] = useState({});
  const [fieldErrors, setFieldErrors] = useState({});
  const navigate = useNavigate();

  const {
    authDispatch,
    authState: {
      auth: { loading, error, data }
    },
  } = useStateContext();

  useEffect(() => {
    if (error) {
      for (const item in error) {
        setFieldErrors({ ...fieldErrors, [item]: error[item][0] });
      }
    }
  }, [error])

  useEffect(() => {
    if (data) {
      navigate("/auth/login");
    }
  }, [data])


  console.log("loading", loading);
  console.log("error", error);
  console.log("data", data);

  const onChange = (e, { name, value }) => {
    setForm({ ...form, [name]: value });
  };


  console.log("form", form);

  const registerFormValid =
    !form.username?.length ||
    !form.firstname?.length ||
    !form.lastname?.length ||
    !form.email?.length ||
    !form.password?.length;

  const onSubmit = () => {
    setFieldErrors({});
    register(form)(authDispatch);
  }

  return { form, onChange, registerFormValid, onSubmit, loading, fieldErrors };
};